/* PUBLICACOES */
export const GET_PUBLICACOES = "GET_PUBLICACOES"
export const GET_PUBLICACOES_PENDENTES = "GET_PUBLICACOES_PENDENTES"
export const GET_PUBLICACOES_SUCCESS = "GET_PUBLICACOES_SUCCESS"
export const GET_PUBLICACOES_FAIL = "GET_PUBLICACOES_FAIL"
export const GET_PUBLICACAO_SUCCESS = "GET_PUBLICACAO_SUCCESS";
export const GET_PUBLICACAO_FAIL = "GET_PUBLICACAO_FAIL";
export const GET_PUBLICACAO = "GET_PUBLICACAO";
export const UPDATE_PUBLICACAO = "UPDATE_PUBLICACAO"
export const UPDATE_PUBLICACAO_SUCCESS = "UPDATE_PUBLICACAO_SUCCESS"
export const UPDATE_PUBLICACAO_FAIL = "UPDATE_PUBLICACAO_FAIL"
export const NEXT_PAGE = "NEXT_PAGE"
export const PREVIOUS_PAGE = "PREVIOUS_PAGE"
export const FIRST_PAGE = "FIRST_PAGE"
export const LAST_PAGE = "LAST_PAGE"